import { useEffect, useState } from 'react'

import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { HistoryEntity } from 'commons/types/DTO/bank/historyAudit'
import { Request } from 'commons/utils/request'
import { HistoryAuditListPayload, HistoryAuditListResponse } from '~bank-entity-history/types'

import { handlerServerError } from '@orbit/errors'

export const useHistoryAuditList = () => {
  const [filter, setFilter] = useState<Partial<HistoryAuditListPayload>>({
    timeTo: new Date(Date.now()).toISOString()
  })
  const [accumulatedItems, setAccumulatedItems] = useState<HistoryEntity[]>([])

  const { data, isFetching, isRefetching, isSuccess, isError, error } = useQuery<void, Error, HistoryAuditListResponse>(
    {
      queryKey: ['history', filter],
      queryFn: () => Request.post(Request.urls.bank.webPageHistoryList, filter),
      placeholderData: keepPreviousData
    }
  )

  useEffect(() => {
    if (data && isSuccess) {
      if (data.config.lastID) {
        setAccumulatedItems((prev) => [...prev, ...data.items])
      } else {
        setAccumulatedItems(data.items)
      }
    }
  }, [isSuccess, data])

  useEffect(() => {
    if (isError && error) {
      handlerServerError(error)
    }
  }, [isError, error])

  return {
    data,
    items: accumulatedItems,
    isRefetching,
    isFirstFetching: isFetching && !isRefetching,
    setFilter
  }
}
